import { Label, LabelProps, PanelProps } from "@mcleod/components";
import { AbstractLinePanel } from "./AbstractLinePanel";
import { FinalizedExample } from "./FinalizedExample";

export class AddlExampleLinePanel extends AbstractLinePanel {
    constructor(name: string, propDef: any, examples: FinalizedExample[],
        props?: Partial<PanelProps>) {
        super(name, propDef, examples, props);
    }

    protected override build(name?: string, propDef?: any) {
        const labelName = new Label({ ...this.getNameColumnDef(name) });
        this.add(labelName);
        const labelDescr = new Label({ ...this.getDescrColumnDef(propDef?.description) });
        this.add(labelDescr);
    }

    protected getNameColumnDef(text: string = ""): Partial<LabelProps> {
        return { text, width: 350, fontBold: true };
    }

    protected getDescrColumnDef(text: string = ""): Partial<LabelProps> {
        return { text, fillRow: true };
    }
}
